import { useInfiniteQuery } from "@tanstack/react-query";
import { queryService } from "../services/query-service";
import { ConversationsListParams } from "../models/api-types";
import { QueryKeys } from "../config/query-keys";
import useAuthStore from "@/store/use-auth-store";

export function useConversations(
  params: Omit<ConversationsListParams, "page"> = {},
  options?: { enabled?: boolean }
) {
  const { user, accessToken } = useAuthStore();

  return useInfiniteQuery({
    queryKey: [
      ...QueryKeys.CONVERSATIONS.list,
      user?._id, // 🔐 User ID eklendi
      params.limit,
      params.sortBy,
      params.search || params.searchTerm, // search parametresi kullan
      params.module, // modül listesi ile hub listesi ayrı cache
    ],
    queryFn: ({ pageParam = 1 }) =>
      queryService.getConversations({
        ...params,
        page: pageParam,
        limit: params.limit || 20, // Default 20 per page
      }),
    getNextPageParam: (lastPage) => {
      const meta = lastPage.data?.meta;
      if (!meta) {
        return undefined;
      }

      // API totalPages (çoğul) gönderiyor
      const page = meta.page;
      const totalPages = meta.totalPages ?? meta.totalPage ?? 0;

      // API 1-indexed kullanıyor (page: 1, 2, 3...)
      // Eğer mevcut sayfa toplam sayfadan küçükse, bir sonraki sayfayı döndür
      return totalPages > 0 && page < totalPages ? page + 1 : undefined;
    },
    initialPageParam: 1,
    enabled: (options?.enabled ?? true) && !!(user && accessToken), // 🛡️ Auth guard eklendi
    staleTime: 1000 * 30, // 30 saniye fresh (eskisi 5 dakika)
    retry: 2,
    refetchOnWindowFocus: false,
  });
}
